<template>
<v-container>
    <v-text-field v-model="search" placeholder="Rechercher une intervention" prepend-inner-icon="mdi-magnify" append-icon="mdi-filter-variant" filled rounded dense class="mb-4" ></v-text-field>

    <v-row>
    <v-col cols="12" v-for="item in filteredList" :key="item.tsk_id" class="pa-2">
        <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 1 : 3" class="rounded-xl pa-4" style="cursor:pointer;" 
                :to="(inSlider == undefined || inSlider ) ? {
                name: $route.matched[1].name + '-slide-task', params: { ent_id: $route.params.ent_id, sit_id: item.tsk_sit_id, tsk_uid: item.tsk_uid }
                } : '/tasks/' + item.tsk_uid">
                <v-row no-gutters>
                    <v-col cols="2" class="">
                        <v-icon size="60" :color="'blue'" class="mr-4">mdi-order-bool-ascending-variant</v-icon>
                    </v-col>
                    <v-col cols="7" class="">
                        <span class="text-h6 font-weight-bold mr-2 text-uppercase"><v-icon>mdi-face-agent</v-icon>&nbsp;
                            {{ item.usr_lastName }}
                            {{ item.usr_firstName && item.usr_firstName.length ? item.usr_firstName : '' }}
                        </span><br />
                        <span class="body-2 grey--text text--darken-2 text-truncate"><v-icon>mdi-town-hall</v-icon>&nbsp;{{ item.sit_town }} : {{  item.sit_name }}</span><br />
                        
                        <v-chip :x-small="$root.$mobileView" class="ma-2" label outlined :color="stateListById[item.tsk_sta_id].sta_color">
                            {{ stateListById[item.tsk_sta_id].sta_label }}
                        </v-chip>
                        <v-chip :x-small="$root.$mobileView" class="ma-2" label outlined :color="typeListById[item.tsk_typ_id].typ_color">{{ typeListById[item.tsk_typ_id].typ_name }}</v-chip>
                    </v-col>
                    <v-col cols="3" class="text-right">
                        <v-chip :small="$root.$mobileView" label outlined color="green">{{(!$root.$mobileView) ? 'Passage :' : ''}} {{ $date(item.tsk_date_lastdonetask).format('DD/MM/YYYY') }}</v-chip><br /><br />
                        <v-chip v-if="item.tsk_doc_id" label outlined class="pa-2 pb-2 pl-10 pr-10" color="secondary" @click.stop.prevent="downloadVouch(item.tsk_doc_id)">
                            <v-icon left color='red' title="Télécharger le compte rendu">
                                mdi-file-download
                            </v-icon>
                        </v-chip>
                    </v-col>
                </v-row>
            </v-card>
        </v-hover>
    </v-col>
    </v-row>
    <v-alert v-if="filteredList.length === 0" type="error" class="mt-4">
    Aucune tache enregistré
    </v-alert>
    <v-pagination 
        v-if="pagination.totalItems > 0"
        v-model="page" 
        :length="Math.ceil(pagination.totalItems / (pagination.rowsPerPage === -1 ? pagination.totalItems : pagination.rowsPerPage))" 
        :total-visible="7"
        class="mt-4 d-flex justify-center"
        @input="fetchList"
    ></v-pagination>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useTaskStore } from '@/stores/task'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import { useFilterStore } from '@/stores/filter'
import { useDocumentStore } from '@/stores/document'

import { filterUpdateService } from '@/rxjsServices'

export default {
    name: 'site-list',
    props: [ 'searchBar', 'addItemButton', 'inSlider', 'sit_ent_id' ],
    components: { },
    computed: {
        ...mapState(useTaskStore, {itemList: 'itemList', metaItems: 'metaItems' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapState(useFilterStore, {filterItem: 'item', getUrlFiter: 'getUrlFiter' }),
        sitId(){
            if( this.$route?.params?.sit_id ){
                return this.$route.params.sit_id
            } else {
                return 0
            }
        },
        filteredList() {
            if (!this.search) return this.itemList;
            
            const searchLower = this.search.toLowerCase();
            return this.itemList.filter(item => {
                return (
                    item.ent_name.toLowerCase().includes(searchLower) ||
                    item.tty_name.toLowerCase().includes(searchLower) //|| item.lst_site.toLowerCase().includes(searchLower)
                );
            });
        }
    },
    data: function () {
        return {
            loading: { getgetTaskItems: false, getXls: false },
            validFrom: true,
            massEditDialog: false,
            fieldStyle: { outlined: true, dense: true },
            taskSelected : [],
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            page: 1,
            headers: [
                { text: 'Commune / adresse',  align: 'left', value: 'ent_name'},    
                { text: 'Action',            align: 'left', value: 'tty_name'},
                { text: 'Date',              align: 'left', value: 'tsk_date_plan'},
                { text: 'Etat',              align: 'left', value: 'sta_label'},
                { text: '-',                 align: 'right', value: 'tsk_id'},
            ],
        }
    },
    //beforeMount: function(){ },
    created(){
        // modification au niveau du filtre
        this.subscribeFilter = filterUpdateService.getFilter().subscribe(message => {
            if (message) {
                this.fetchList()
            }
        })
    },
    async mounted(){
        if(this.$root.$mobileView){
            this.headers = [
                { text: 'Commune / adresse',  align: 'left', value: 'ent_name'},  
                { text: 'Date',              align: 'left', value: 'tsk_date_plan'},
            ]
        }
        this.fetchList()
    },
    methods: {
        ...mapActions(useTaskStore, { fetchItems: 'fetchItems', downloadItems: 'downloadItems' }),
        ...mapActions(useDocumentStore, { downloadDocument: 'downloadItem' }),
        async fetchList(){
            let withcounttask = (this.getUrlFiter.length > 1) ? ',withcounttask' : ''
            withcounttask += (this.sit_ent_id) ? '&sit_ent_id=' + this.sit_ent_id : ''

            const perPage = this.pagination.rowsPerPage === -1 ? 9999 : this.pagination.rowsPerPage;
            const url = `?extended=withtasktype,withentity,withstate,withzone,withsite${withcounttask}${this.getUrlFiter}&page=${this.page}&per_page=${perPage}`;

            await this.fetchItems( url )
            // Mise à jour du total depuis la réponse API
            if (this.metaItems) {
                this.pagination.totalItems = this.metaItems.total;
            }
        },
        async downloadTasks(){
            const report = await this.downloadItems('extended=withtasktype,withentity&per_page=false')
            this.$download(report, "liste.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
        },
        async downloadVouch(docId){
            const report = await this.downloadDocument( docId )
            this.$download(report.blob, 'bdp', report.contentType)
        },
    },
}
</script>